import { securedApiRequest } from "./SecuredApi";


/**
 * Submit a trip rating and optional feedback comment to the backend.
 *
 * @param {Object} ratingData - An object containing rating details.
 * @param {string} ratingData.reference - The trip reference ID.
 * @param {number} ratingData.trip_rating - The numerical rating for the trip.
 * @param {string} [ratingData.comment] - Optional feedback comment (max 500 characters).
 * @returns {Promise<Object>} - Resolves with a success message or response from the server.
 * @throws Will throw an error if the request fails or validation fails.
 */
export const submitRating = (ratingData) => {
    const { reference, trip_rating, comment, name } = ratingData;

    const payload = {
        trip_reference: reference,
        name: name,
        occupation: "Customer",
        testimonial: comment || "No comment provided.",
        rating: trip_rating,
        is_verified: false,
    };

    return securedApiRequest(`/submit-testimonial/`, "POST", payload);
};
